<template>
    <div class="d-flex" id="avaliacoes-home" v-if="avaliation">
        <BannerAvaliacoesHome :avaliation='avaliation'/>
        <div id="avaliacoes-intro">
            <p>Olá, {{ avaliation.customer_name }}.</p>
            <p>Clique nos produtos abaixo para avaliá-los individualmente.</p>
        </div>
        <div id="avaliacoes-list">
            <AvaliacoesListItem
                v-for="(product, index) in sortedProductList"
                :key="product.product_id"
                :product-data="product"
            />
        </div>

        <!-- <AvaliacoesFooter /> -->
    </div>
</template>

<script>
    import AvaliacoesFooter from './AvaliacoesFooter.vue';
    import BannerAvaliacoesHome from './BannerAvaliacoesHome.vue';
    import AvaliacoesListItem from './AvaliacoesListItem.vue';

    export default {
        name: 'AvaliacoesHome',

        props: {
            avaliation: {
                type: Object,
            },
        },

        components: {
            AvaliacoesListItem,
            AvaliacoesFooter,
            BannerAvaliacoesHome,
        },

        data() {
            return {};
        },

        computed: {
            sortedProductList() {
                if (!this.avaliation) {
                    return null;
                }

                return this.avaliation.products.sort((a, b) => {
                    if (a.note && !b.note) {
                        return 1;
                    } else if (!a.note && b.note) {
                        return -1;
                    } else {
                        return 0;
                    }
                });
            },
        },

        methods: {},
    };
</script>
